import { useLocation } from "react-router-dom";

// On the marketing domain, customer-app routes are sent to app.clientdeskva.com
// (same path, query and hash) so visitors never use the outdated auth screens.
const APP_URL = process.env.REACT_APP_APP_URL;
const MARKETING_URL = process.env.REACT_APP_MARKETING_URL;
const APP_PREFIXES = [
  "/login", "/signup", "/verify-email", "/forgot-password", "/reset-password",
  "/accept-invite", "/setup", "/create-organization", "/app", "/portal",
  "/book", "/booking", "/f",
];

function marketingHosts() {
  if (!MARKETING_URL) return [];
  const host = new URL(MARKETING_URL).hostname.replace(/^www\./, "");
  return [host, `www.${host}`];
}

export function appRedirectTarget(hostname, pathname, search, hash) {
  if (!APP_URL || !marketingHosts().includes(hostname)) return null;
  const isAppRoute = APP_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
  return isAppRoute ? `${APP_URL.replace(/\/$/, "")}${pathname}${search}${hash}` : null;
}

export default function AppHostRedirect({ children }) {
  const { pathname, search, hash } = useLocation();
  const target = appRedirectTarget(window.location.hostname, pathname, search, hash);
  if (target) {
    window.location.replace(target);
    return null;
  }
  return children;
}
